<template>
    <Loading v-bind:show="showLoadingCancelados" v-if="$featureToggle && $featureToggle.INTEGRA_MENSALIDADES_CANCELADOS">
        <PageTitle title="Mensalidades - Canceladas" />
        <Grid v-if="dadosAba"
              v-bind:Data="dadosAba.mensalidades"
              v-bind:Header="headerCanceladas"
              Name="MensalidadesCanceladas"
              OrderBy="anoMes"
              v-bind:HeaderDetalhes="headerDetalheCancelados"
              v-bind:DetalhesCombo1="dadosAba.periodo"
              v-bind:DetalhesCombo2="null"
              v-bind:DetalhesCombo3="null" />
    </Loading>
</template>
<script>
    import Grid from '@/components/Grid';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';
    import Mensalidades from '@/services/MensalidadesService.js';
  export default {
    components: {
        Grid,
        Loading,
        PageTitle
    },
    created() {
      this.mensalidadesService = new Mensalidades(this);

      //Verifica se tem aluno selecionado
      if (!sessionStorage.Aluno) {
        this.$router.push('home');
      }
      else {
        let a = JSON.parse(sessionStorage.Aluno);
        //Coloca o perfil de aluno disponível na variável aluno
        if (a.PerfilAluno) {
          this.aluno = a.PerfilAluno;
          //Verifica se os dados da Aba ja esta carregado
          if (a.MensalidadesCanceladas) {
            this.dadosAba = a.MensalidadesCanceladas;
          }
          else {
            this.dadosAba = this.cancelados();
          }
        }
        else
          this.$router.push('home');
      }
    },
    beforeDestroy() {
      let aluno = JSON.parse(sessionStorage.Aluno);

      //Armazena os dados da aba pra nao precisar carregar novamente
      aluno.MensalidadesCanceladas = this.dadosAba;
      sessionStorage.setItem("Aluno", JSON.stringify(aluno));
    },
    data() {
      return {
        aluno: null,
        headerCanceladas: [
          {
            Titulo: "Cod. Boleto",
            Field: "numero_documento",
            Width: "80px",
            Tipo: "numero"
          },
          {
            Titulo: "Ano/Mês",
            Field: "anoMes",
            Width: "80px",
            Tipo: "texto"
          },
          {
            Titulo: "Valor Mensalidade",
            Field: "valor_titulo",
            Width: "50px",
            Tipo: "moeda"
          },
          {
            Titulo: "Data/Hora da Exclusão",
            Field: "data_exclusao",
            Width: "80px",
            Tipo: "date"
          },
          {
            Titulo: "Usuário",
            Field: "usuario_transacao",
            Width: "80px",
            Tipo: "texto"
          }
        ],
        headerDetalheCancelados: [
          {
            Titulo: "Convênio",
            Field: "convenio",
            Tipo: "texto"
          }
        ],
        dadosAba: null,
        showLoadingCancelados: false,
        mensalidadesCanceladas: null,
      }
    },
    methods: {
      cancelados() {
        if (this.$featureToggle.INTEGRA_MENSALIDADES_CANCELADOS) {
          this.showLoadingCancelados = true;
          this.mensalidadesService.ListarMensalidadesAlunoCanceladas({
            CodigoAluno: this.aluno.codigoAluno,
            CodigoEspecialidade: this.aluno.codigoEspecialidade,
            Pagina: 1,
            ItensPagina: 100
          }).then(
            data => {
              if (data.ok) {
                this.dadosAba = data.dados;
              }
              else {
                this.$modal.alert(data.mensagem);
              }
            },
            error => {
              this.$modal.error((error.body?.Mensagem || 'Ocorreu um erro ao tentar buscar os dados.'), (error.body?.Detalhe || error?.response?.statusText || error.message));
            }).finally(() => {
              this.showLoadingCancelados = false;
            });
        }
        else {
          this.$modal.alert(this.$msgFeatureToggle);
        }
      }
    }
  }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .md-field {
    max-width: 100%;
    font-weight: bold;
  }
</style>
